/* eslint-disable no-unused-vars */
import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Moment from 'react-moment';
import { FormattedMessage } from 'react-intl';
import styles from './comment.module.scss';
import CommentParagraph from './CommentParagraph';

const Comment = ({ comment, data, myForms, driverPermit }) => (
    <div className={styles.root}>
      <div className={styles.first}>
        {!myForms
          ? (
            <Avatar
              aria-label="recipe"
              className={styles.avatar}
              src="/static/media/default_avatar.5b4c72f1.jpg"
            />
          ) : (
            <img className={styles.image} src={comment?.image || '/static/media/default_avatar.5b4c72f1.jpg'} alt="" />
          )}
        {!driverPermit && (
        <div className={styles.content}>
          <span
            style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#242E42' }}
          >
          &nbsp;&nbsp;
            {comment?.commented_by?.fullname}
          </span>
          <span style={{ marginLeft: '0.5rem', color: '#8C9EA7' }}>
            <span>
              <FormattedMessage
                id="workorder.detail.comment"
                defaultMessage="commented"
              />
            </span>
            &nbsp;
            <Moment format="on MM/DD/YYYY " local>
              {comment.current_date}
            </Moment>
            at
            <Moment format=" hh:mm A" local>
              {comment.current_date}
            </Moment>
          </span>
        </div>
        )}
        {driverPermit && (
          <div className={styles.content}>
            <span style={{ marginLeft: '0.5rem', color: '#8C9EA7' }}>
              <span>
                <FormattedMessage
                  id="adp.detail.comment"
                  defaultMessage="Comment added by"
                />
              </span>
              {' '}
              <span
                style={{ fontSize: '1.1rem', fontWeight: '500', color: '#000' }}
              >
                {comment?.commented_by?.fullname}
              </span>
              &nbsp;
              <Moment format="on MM/DD/YYYY" local>
                {comment?.date}
              </Moment>
              &nbsp;at&nbsp;
              <Moment format="hh:mm A" local>
                {comment?.date}
              </Moment>
            </span>
          </div>
        )}
        <div className={styles.action}>{/* <span>Action</span> */}</div>
        {/* <IconButton>
          <MoreHorizIcon />
        </IconButton> */}
      </div>

      { driverPermit
      && (<div className={styles.second}>
          <CommentParagraph comment={comment?.comment ? comment?.comment : comment?.description} />
          </div>)}
      {myForms && (
        <div className={styles.second}>
          <p
            style={{ lineBreak: 'anywhere' }}
            className="d-inline comment-paragraph-text"
          >
            {comment?.comment ? comment?.comment : comment?.description ||''}
          </p>
        </div>
      )}

      <div className={styles.second}>
        <span style={{ color: '#242E42' }}>{comment?.description?.replaceAll('[', '')?.replaceAll(']', ' ')}</span>
      </div>
      {/* {comment.attachments.map(e=><div className={styles.second}>
        {e.content_type==="application/pdf"?
        <a href={e.image} download target="_blank" rel="noopener noreferrer" >{e.file_name}</a>:
        <img src={e.image} style={{maxWidth:'695px'}}  alt={e.id} />
        }
      </div>)} */}
    </div>
  );

export default Comment;
